import script from "./FiuSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FiuSection.vue?vue&type=script&setup=true&lang=js"

import "./FiuSection.vue?vue&type=style&index=0&id=e42d005a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e42d005a"]])

export default __exports__